import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, ApiRequestOptions } from './api.service';
import { AuditLogDto, AuditSource, GetAuditLogsQuery } from '../models/audit-log.model';

@Injectable({
  providedIn: 'root',
})
export class AuditService {
  private api = inject(ApiService);

  private readonly defaultOptions: ApiRequestOptions = {
    showLoader: false,
    showErrorToaster: false,
  };

  /**
   * Creates a new audit log entry on the Node.js server.
   * @param dto The audit log data to be stored.
   */
  createAuditLog(dto: AuditLogDto): Observable<any> {
    // Ensure source is set to WEB if not provided
    const payload = {
      ...dto,
      source: dto.source || AuditSource.WEB,
    };

    return this.api.post('/audit-logs', payload, this.defaultOptions);
  }

  /**
   * Fetches audit log entries from the server.
   * @param query The filter and pagination options.
   */
  getAuditLogs(query?: GetAuditLogsQuery): Observable<any> {
    const params: any = {};
    if (query) {
      Object.keys(query).forEach((key) => {
        let value = (query as any)[key];
        if (value !== undefined && value !== null) {
          // If value is an array, join it with commas for the API
          if (Array.isArray(value)) {
            value = value.join(',');
          }
          params[key] = value;
        }
      });
    }

    return this.api.get('/audit-logs', params, this.defaultOptions);
  }
}
